import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@components';
import ArrowDown from '@icons/arrow-down.svg';

const DownloadButton = ({
  onDownload,
  label,
  variant,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading || disabled) {
      return;
    }

    setLoading(true);

    try {
      await onDownload();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      loading={loading}
      disabled={disabled}
      leftIcon={<ArrowDown />}
    >
      {label}
    </Button>
  );
};

DownloadButton.propTypes = {
  onDownload: PropTypes.func.isRequired,
  label: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
};

DownloadButton.defaultProps = {
  label: 'Baixar CSV',
  variant: 'outlined',
  disabled: false,
};

export default DownloadButton;
export { DownloadButton };
